import React, { useState } from 'react';
import PromoCodeGenerator from './PromoCodeGenerator';
import PromoCodeList from './PromoCodeList';
import CampaignDashboard from './CampaignDashboard';
import PromoAnalytics from './PromoAnalytics';
import './PromoCodeDashboard.css';

type TabKey = 'generator' | 'list' | 'campaigns' | 'analytics';

interface TabDef {
  key: TabKey;
  label: string;
}

const TABS: TabDef[] = [
  { key: 'generator', label: 'Generator' },
  { key: 'list', label: 'Code List' },
  { key: 'campaigns', label: 'Campaigns' },
  { key: 'analytics', label: 'Analytics' },
];

interface PromoCodeDashboardProps {
  user: any;
}

const PromoCodeDashboard: React.FC<PromoCodeDashboardProps> = ({ user }) => {
  const [activeTab, setActiveTab] = useState<TabKey>('generator');

  const renderTabContent = () => {
    switch (activeTab) {
      case 'generator':
        return <PromoCodeGenerator />;
      case 'list':
        return <PromoCodeList />;
      case 'campaigns':
        return <CampaignDashboard />;
      case 'analytics':
        return <PromoAnalytics />;
      default:
        return null;
    }
  };

  return (
    <div className="promo-dashboard">
      <div className="promo-tabs">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            className={`tab-btn ${activeTab === tab.key ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="promo-tab-content">
        {renderTabContent()}
      </div>
    </div>
  );
};

export default PromoCodeDashboard;
